import { render, staticRenderFns } from "./BuscarItinerariosTabla.vue?vue&type=template&id=52cec697"
import script from "./BuscarItinerariosTabla.vue?vue&type=script&lang=js"
export * from "./BuscarItinerariosTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports